export type MissionData = {
    id: number;
    title: string;
    subtitle?: string;
    agentName?: string;
    description?: string;
    illustration?: string;
    cartesMachineRoulete?: number[];
    cartesMachineQuiz?: number[];
    cartesMachineMap?: number[];
    cartesMachineAR?: number[];
    cartesMachinesTextTrou?: number[];
    cartesMachineQuestion?: number[];
    cartesMachinAscenseur?: number[];
    dataUrl?: string;
    dataQuiz?: { [key: number]: { key: string; isFinalQuiz: boolean } };
    duree?: number;
};

export const contentData: { missions: MissionData[] } = {
    missions: [
        {
            id: 0,
            title: 'Tutoriel',
            illustration: './images/agent-image-6.png',
            subtitle: 'Vous incarnez l’agent spécial',
            agentName: 'Habib Rond',
            description:
                'Pour démarrer,\nretourner <span class="bold">la carte\u00A01\u00A0!</span>',
            dataUrl: './data/tutoriel/',
            duree: 5,
            cartesMachinAscenseur: [8],
        },
        {
            id: 1,
            title: 'Coqueluche & Hib',
            illustration: './images/agent-image.png',
            subtitle: 'Vous incarnez l’agent spécial',
            agentName: 'Maïté Tine',
            description:
                'Rendez-vous\nau<span class="bold">bureau\u00A0d’Habib\u00A0Rond</span> et\u00A0retournez\u00A0<span class="bold">la\u00A0carte\u00A09\u00A0!</span>',
            cartesMachineRoulete: [29],
            cartesMachineQuiz: [81, 76],
            cartesMachineMap: [5],
            dataUrl: './data/mission1/',
            dataQuiz: {
                81: {
                    key: 'quizData',
                    isFinalQuiz: false,
                },
                76: {
                    key: 'finalQuizData',
                    isFinalQuiz: true,
                },
            },
        },
        {
            id: 2,
            title: 'Pneumocoque',
            illustration: './images/agent-image-3.png',
            subtitle: 'Vous incarnez l’agent spécial',
            agentName: 'Maïté Tine',
            description:
                'Rendez-vous dans<span class="bold">la\nchambre d\'Arthur Bulette</span> et\u00A0retournez\u00A0<span class="bold">la\u00A0carte\u00A01\u00A0!</span>',
            cartesMachineAR: [27],
            cartesMachineQuestion: [48],
            cartesMachinesTextTrou: [52],
        },
    ],
};
